import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface SidebarRailSectionProps {
  children: React.ReactNode;
  className?: string;
}

/** Visual separator between intent-first rail stacks (Start / Resume / Navigate / Scope). */
export function SidebarRailSection(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("border-b border-sidebar-border/50 py-1 last:border-b-0", "group-data-[collapsible=icon]:py-0.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}